export const colleaguesMain = {
    title: "Praticiens",
    loading: "Chargement en cours…",
    none: "Aucun praticien"
}